import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Body2, Dot, IconButton, TrashIcon, Tooltip, MoveIcon } from "@activecollab/components";
import PropTypes from "prop-types";
import { getPersonalizedDateFormat } from "~/store/selectors/selector.configOptions";
import { formatDateSmart } from "~/utils/date";

const ApiTokensItem = ({ item, setDeleteElement, setSelectedToken }) => {
  const { t } = useTranslation();
  const format = useSelector(getPersonalizedDateFormat);

  return (
    <>
      <div className="tw-flex tw-items-center tw-pl-5 tw-pr-4 tw-min-h-[48px] tw-gap-6 tw-border-0 tw-border-t tw-border-solid tw-border-theme-400">
        <Body2
          overflow="truncate"
          whitespace="no-wrap"
          className="tw-w-56 tw-shrink-0"
        >
          {item.client_display_name}
        </Body2>
        <Body2
          color="tertiary"
          className="tw-w-[90px] tw-shrink-0"
        >
          {formatDateSmart(item.last_used_on, format)}
        </Body2>
        <Body2
          className="tw-flex tw-w-[236px] tw-shrink-0 tw-items-center tw-select-none tw-overflow-hidden"
          color="tertiary"
        >
          <>
            <span className="tw-flex tw-shrink-0">{item.token}</span>
            {[...Array(15)].map((_, index) => (
              <Dot
                data-testid="dot"
                key={`dot-${index}`}
                size={8}
                className="tw-ml-1 tw-mt-0.5 tw-shrink-0"
                color="var(--color-theme-600)"
              />
            ))}
          </>
        </Body2>
        <div className="tw-w-[90px] tw-shrink-0" />
        <div className="tw-flex tw-gap-4">
          <Tooltip title={t("Use Token")}>
            <IconButton
              variant="text gray"
              onClick={() => setSelectedToken(item)}
            >
              <MoveIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={t("Delete Token")}>
            <IconButton
              className="tw-shrink-0"
              variant="text gray"
              onClick={() => setDeleteElement(item)}
            >
              <TrashIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </>
  );
};

ApiTokensItem.propTypes = {
  item: PropTypes.object,
  setDeleteElement: PropTypes.func,
  setSelectedToken: PropTypes.func,
};

export default ApiTokensItem;
